import React from "react";
import { Box } from "@mui/system";
import Modal from "@mui/material/Modal";
import { Grid } from "@mui/material";
import DynamicTable from "../../../../../library/custom/dynamicTable/dynamicTable";
import { ViewPastRainFallColumns } from "../../../../../utils/swInspectionHelper";

const ViewPastRainFall = (props) => {
  return (
    <>
      <Modal
        open={props?.open}
        onClose={props?.handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="caseSummaryModal"
      >
        <Grid className="modalContainer viewPast7RainFallModal">
          <Box className="modalBox">
          <div className="modalHeaderTitle"></div>
            <div className="modalHeader">
              <div className="modalHeaderClose" onClick={props?.handleClose}>
                X
              </div>
            </div>
            <div className="modalBody modalScroll">
              <DynamicTable
                title="Past 7 Day Rainfall Data"
                columns={ViewPastRainFallColumns}
                data={props?.swRainFallDataModalData?.historyPrecipList ?? []}
              />
            </div>
          </Box>
        </Grid>
      </Modal>
    </>
  );
};

export default ViewPastRainFall;
